<template>
  <section class="custom-legend">
    <ul class="custom-legend__list">
      <li
        v-for="(dataset, index) in datasets"
        :key="index"
        class="custom-legend__item"
        :class="{
          'hidden-label': selectedIndex !== index && selectedIndex !== null,
          active: selectedIndex === index,
        }"
        @click="hideOthers(index)"
      >
        <span class="custom-legend__item-marker">
          <svg
            version="1.1"
            baseProfile="full"
            width="60"
            height="24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g v-if="isLineChart(index)">
              <circle
                v-if="notGoals(index)"
                cx="29"
                cy="12"
                r="3"
                :style="getBorderColor(dataset, 'stroke')"
                :fill="dataset.backgroundColor"
                stroke-width="2"
              />
              <line
                x1="16"
                y1="12"
                x2="42"
                y2="12"
                style="stroke-width: 2"
                :style="getBorderColor(dataset, 'stroke')"
              />
            </g>
            <g v-if="!isLineChart(index)">
              <rect
                width="30"
                height="12"
                x="16"
                y="7"
                style="stroke-width: 2"
                :style="getBorderColor(dataset, 'fill')"
              />
            </g>
          </svg>
        </span>
        <span class="custom-legend__item-label" :class="itemLabelType">
          <!-- {{ dataset.label }} -->
          {{ chartSelection(index) }}
        </span>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  data() {
    return {
      selectedIndex: null,
    };
  },
  computed: {
    datasets() {
      return this.$store.state.visualization.chartData.datasets;
    },
    itemLabelType() {
      const chartType = this.$store.state.visualization.chartType;
      return `custom-legend__item-label--${chartType}`;
    },
  },
  methods: {
    isLineChart(index) {
      const ds = this.$store.state?.visualization?.chartData?.datasets[index];
      if (ds.type === "line" || ds.type === undefined) {
        return true;
      }
      return false;
    },
    notGoals(index) {
      const ds = this.$store.state?.visualization?.chartData?.datasets[index];
      if (ds.label.match(/DVA Goal/)) {
        return false;
      }
      return true;
    },
    getBorderColor(dataset, type = "stroke") {
      let color = dataset?.borderColor;
      if (type === "stroke") {
        return `stroke: ${color}`;
      } else if (type === "fill") {
        color = dataset?.backgroundColor;
        return `fill: ${color}`;
      }
    },
    chartSelection(index) {
      let label =
        this.$store.state.visualization.chartData.datasets[index]?.label;
      if (label.match(/Goal/)) {
        const counties = this.$store.state?.visualization?.countySelections;
        if (counties?.length === 1) {
          label = `${counties[0]} ${label}`;
        }
      }
      return label;
    },
    hideOthers(index) {
      if (this.selectedIndex !== index) {
        this.selectedIndex = index;
      } else {
        this.selectedIndex = null;
      }
      this.$emit("hide-others", index);
    },
  },
};
</script>

<style lang="scss">
.hidden-label {
  opacity: 50%;
}
.custom-legend {
  text-align: center;
  padding: 20px 0 0 0;
  margin-bottom: 0;
  &__list {
    font-family: "Helvetica Neue", "Helvetica", "Arial", sans-serif;
    font-size: 12px;
    font-weight: bold;
    list-style-type: none;
    width: 75%;
    margin: auto;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  &__item {
    color: black;
    display: flex;
    align-content: flex-start;
    align-items: baseline;
    cursor: pointer;
    min-width: 300px;
    text-align: left;
    &:hover {
      color: #eb7008;
    }
    &.active {
      color: #a25926;
    }
  }
  &__item-label {
    position: relative;
    &--line {
      top: -7px;
    }
    &--bar {
      top: -4px;
    }
  }
}
</style>
